module.exports = __webpack_public_path__ + "img/logo-icjr.df51bb5b.png";